import { Directive, ElementRef, HostListener, inject, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: 'img[appImgFallback]',
  standalone: true,
})
export class ImgFallbackDirective {
  private el = inject(ElementRef<HTMLImageElement>);
  private renderer = inject(Renderer2);

  @Input() appImgFallback = '';

  @HostListener('error')
  onError(): void {
    const img = this.el.nativeElement;
    const name = this.appImgFallback || img.alt || '?';
    const initials = name
      .split(/\s+/)
      .slice(0, 2)
      .map((w: string) => w.charAt(0).toUpperCase())
      .join('');

    const parent = img.parentElement;
    if (!parent) return;

    // Hide the broken image
    this.renderer.setStyle(img, 'display', 'none');

    // Create a text-based fallback
    const fallback = this.renderer.createElement('div');
    this.renderer.setAttribute(fallback, 'aria-hidden', 'true');
    this.renderer.setStyle(fallback, 'display', 'flex');
    this.renderer.setStyle(fallback, 'align-items', 'center');
    this.renderer.setStyle(fallback, 'justify-content', 'center');
    this.renderer.setStyle(fallback, 'width', '100%');
    this.renderer.setStyle(fallback, 'height', '100%');
    this.renderer.setStyle(fallback, 'background', 'linear-gradient(135deg, #f1f5f9, #e2e8f0)');
    this.renderer.setStyle(fallback, 'border-radius', '0.5rem');
    this.renderer.setStyle(fallback, 'font-size', '0.75rem');
    this.renderer.setStyle(fallback, 'font-weight', '600');
    this.renderer.setStyle(fallback, 'color', '#64748b');
    this.renderer.setStyle(fallback, 'text-align', 'center');
    this.renderer.setStyle(fallback, 'padding', '0.25rem');
    this.renderer.setStyle(fallback, 'line-height', '1.2');
    this.renderer.setStyle(fallback, 'letter-spacing', '0.025em');

    const text = this.renderer.createText(initials);
    this.renderer.appendChild(fallback, text);
    this.renderer.appendChild(parent, fallback);
  }
}
